import React, { useState, useEffect } from "react";
import "./App.scss";
import Tour from "./component/tour/tour.component";
import Video from "./component/twilio-video/twilio-video.component";
import StartForm from "./component/twilio-start-form/twilio-start-form.component";
import firebase from "firebase/app";
import { RemoveUserInRealTime } from "./firebase/firebase.utils";
import JoinedBar from "./component/joined-bar/joined-bar.component.jsx";
import Audio from "./component/twilio-video/twilio-audio.component";

function App() {
  const [token, setToken] = useState("");
  const [host, setHost] = useState([]);
  const [room, setRoom] = useState("");
  const [guest, setGuest] = useState([]);
  const [start, setStart] = useState(false);
  const [snapshotObj, setSnapshotObj] = useState(null);
  const [userKey, setUserKey] = useState(null);
  const [hostJoined, setHostJoined] = useState(false);

  useEffect(() => {
    if (host.length || guest.length) {
      setStart(true);
    }
  }, [host, guest]);

  useEffect(() => {
    if (room && userKey) {
      var currentUserType = host.length ? "host" : "guest";
      var currentUserPresenceRef = firebase
        .database()
        .ref(`/rooms/${room}/${currentUserType}/${userKey.key}`);
      const roomRef = firebase.database().ref(`/rooms/${room}`);
      roomRef.on("value", (snapshot) => {
        if (snapshot.val()) {
          if (snapshot.val().host) {
            setHostJoined(true);
          } else {
            console.log("Host disconnected");
            setHostJoined(false);
            var updates = {};
            updates["apartmentId"] = null;
            updates["unitId"] = null;
            roomRef.update(updates);
          }
          setSnapshotObj(snapshot.val());
        }
        currentUserPresenceRef.onDisconnect().remove();
      });
    }
  }, [room, userKey]);

  const handleDisconnectFromCall = (e) => {
    e.preventDefault();
    if (userKey) {
      console.log("disconnected");
      RemoveUserInRealTime(room, userKey);
      const roomRef = firebase.database().ref(`/rooms/${room}`);
      roomRef.off("value");
      setStart(false);
      setUserKey(null);
      setRoom("");
      window.location.reload(false);
    }
  };

  return (
    <div className="App">
      <span className="title">LiveTour</span>
      <div className="main-content">
        <div className="tour-container">
          {start ? (
            <Tour
              hostJoined={hostJoined}
              hostDetails={host}
              room={room}
              guest={guest}
              snapshotObj={snapshotObj}
            />
          ) : (
            <div className="hero">
              <span className="hero-title">LiveTour</span>
            </div>
          )}
        </div>
        <div className="side-container">
          {!start ? (
            <StartForm
              storeToken={setToken}
              storeHostDetails={setHost}
              storeGuestDetails={setGuest}
              storeRoomDetails={setRoom}
            />
          ) : (
            <div className="comms-container">
              <div className="video-chat-wrapper">
                {hostJoined && token && room ? (
                  <Video
                    token={token}
                    roomName={room}
                    host={host.length}
                    guest={guest.length}
                  />
                ) : null}

                {hostJoined ? null : (
                  <span className="host-unavailable-text">
                    Host has not joined yet
                  </span>
                )}
              </div>
              <JoinedBar
                hostDetails={host}
                room={room}
                guest={guest}
                snapshotObj={snapshotObj}
                handleUserKey={setUserKey}
              />
              <button
                className="disconnect-btn"
                onClick={handleDisconnectFromCall}
              >
                DISCONNECT
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
